/* ============================================
   KASHISLAND THEME — JAVASCRIPT
   ============================================ */

(function () {
  'use strict';

  /* ---- Sticky Header ---- */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', (document.body.scrollTop || window.scrollY) > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    document.body.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Mobile Nav ---- */
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    mobileNav.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        mobileNav.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ---- Header Search ---- */
  const searchToggle = document.querySelector('[data-toggle-search]');
  const headerSearch = document.getElementById('header-search');
  if (searchToggle && headerSearch) {
    const searchInput = headerSearch.querySelector('[data-header-search-input]');
    const searchClose = headerSearch.querySelector('[data-close-search]');
    const setSearch = (open) => {
      headerSearch.classList.toggle('open', open);
      searchToggle.setAttribute('aria-expanded', open);
      if (open) headerSearch.removeAttribute('inert');
      else headerSearch.setAttribute('inert', '');
      if (open && searchInput) searchInput.focus();
    };
    searchToggle.addEventListener('click', () => {
      setSearch(!headerSearch.classList.contains('open'));
    });
    if (searchClose) searchClose.addEventListener('click', () => setSearch(false));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && headerSearch.classList.contains('open')) setSearch(false);
    });
  }

  /* ---- Product Share (copy link) ---- */
  const copyLinkBtn = document.querySelector('[data-copy-link]');
  if (copyLinkBtn) {
    const copyIcon = copyLinkBtn.querySelector('[data-copy-icon]');
    const checkIcon = copyLinkBtn.querySelector('[data-check-icon]');
    copyLinkBtn.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(window.location.href);
        copyLinkBtn.classList.add('copied');
        copyLinkBtn.setAttribute('aria-label', 'Link copied');
        if (copyIcon) copyIcon.style.display = 'none';
        if (checkIcon) checkIcon.style.display = 'block';
        setTimeout(() => {
          copyLinkBtn.classList.remove('copied');
          copyLinkBtn.setAttribute('aria-label', 'Copy link');
          if (copyIcon) copyIcon.style.display = 'block';
          if (checkIcon) checkIcon.style.display = 'none';
        }, 2000);
      } catch (e) {}
    });
  }

  /* ---- Cart Drawer ---- */
  const cartDrawer = document.getElementById('cart-drawer');
  const cartDrawerOverlay = cartDrawer && cartDrawer.querySelector('.cart-drawer__overlay');
  const cartDrawerClose = cartDrawer && cartDrawer.querySelector('.cart-drawer__close');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var p = document.getElementById('ki-player');
    if (p) p.classList.add('player-bar--cart-hidden');
    refreshCartDrawer();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    var p = document.getElementById('ki-player');
    if (p) p.classList.remove('player-bar--cart-hidden');
  }

  if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeCartDrawer);
  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);

  document.querySelectorAll('[data-open-cart]').forEach(btn => {
    btn.addEventListener('click', (e) => { e.preventDefault(); openCartDrawer(); });
  });

  /* ---- Add to Cart ---- */
  function addToCart(variantId, quantity = 1, sellingPlanId = null) {
    const payload = { id: variantId, quantity };
    if (sellingPlanId) payload.selling_plan = sellingPlanId;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(r => r.json())
      .then(() => {
        updateCartCount();
        openCartDrawer();
      })
      .catch(console.error);
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const counts = document.querySelectorAll('.header-cart__count');
        counts.forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const itemsEl = document.getElementById('cart-drawer-items');
        const totalEl = document.getElementById('cart-total');
        if (!itemsEl) return;

        if (cart.items.length === 0) {
          itemsEl.innerHTML = '<p style="text-align:center;color:var(--color-text-dim);font-family:var(--font-mono);font-size:13px;letter-spacing:0.2em;padding:40px 0;">YOUR CART IS EMPTY</p>';
        } else {
          itemsEl.innerHTML = cart.items.map(item => `
            <div class="cart-item" data-key="${item.key}">
              <div class="cart-item__info">
                <p class="cart-item__title">${item.product_title}</p>
                <p class="cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
                <p class="cart-item__price">${formatMoney(item.final_price)}${item.selling_plan_allocation ? ' <span class="cart-item__recurring">/ month</span>' : ''}</p>
              </div>
              <button class="cart-item__remove" data-key="${item.key}">Remove</button>
            </div>
          `).join('');

          itemsEl.querySelectorAll('.cart-item__remove').forEach(btn => {
            btn.addEventListener('click', () => removeFromCart(btn.dataset.key));
          });
        }

        if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
        updateCartCount();
      });
  }

  function removeFromCart(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(r => r.json())
      .then(() => refreshCartDrawer());
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId || btn.closest('[data-variant-id]')?.dataset.variantId;
    const sellingPlanId = btn.dataset.sellingPlanId || null;
    if (btn.hasAttribute('data-membership-plan') && !sellingPlanId) {
      console.error('Membership plan is missing a monthly selling plan — connect one in Shopify admin.');
      return;
    }
    if (variantId) addToCart(variantId, 1, sellingPlanId);
  });

  /* ---- Product Form / License Selector ---- */
  const licenseOptions = document.querySelectorAll('.license-option');
  licenseOptions.forEach(opt => {
    opt.addEventListener('click', () => {
      licenseOptions.forEach(o => o.classList.remove('selected'));
      opt.classList.add('selected');
      const variantId = opt.dataset.variantId;
      const priceEl = document.querySelector('.product-price');
      const addBtn = document.querySelector('.product-add-btn');
      const variantInput = document.getElementById('variant-input');
      const priceText = opt.querySelector('.license-option__price').textContent;
      const nameText = opt.querySelector('.license-option__name').textContent;
      if (priceEl) priceEl.textContent = priceText;
      if (addBtn) addBtn.dataset.variantId = variantId;
      if (variantInput) variantInput.value = variantId;
      const stickyPrice = document.querySelector('[data-sticky-price]');
      const stickyLicense = document.querySelector('[data-sticky-license]');
      const stickyBtn = document.querySelector('[data-sticky-atc] [data-add-to-cart]');
      if (stickyPrice) stickyPrice.textContent = priceText;
      if (stickyLicense) stickyLicense.textContent = nameText;
      if (stickyBtn) stickyBtn.dataset.variantId = variantId;
      const pagePlayer = document.querySelector('.audio-player');
      if (pagePlayer && pagePlayer.dataset.src === currentSrc) {
        currentPrice = priceText;
        currentVariantTitle = nameText;
        currentVariantId = variantId;
        updatePbMeta();
      }
    });
  });

  /* ---- Sticky Add to Cart Bar ---- */
  const stickyBar = document.querySelector('[data-sticky-atc]');
  const mainAddBtn = document.querySelector('.product-add-btn');
  if (stickyBar && mainAddBtn && 'IntersectionObserver' in window) {
    const stickyObserver = new IntersectionObserver(
      (entries) => {
        const visible = !entries[0].isIntersecting;
        stickyBar.classList.toggle('sticky-atc--visible', visible);
        document.body.classList.toggle('sticky-atc-open', visible);
      },
      { threshold: 0 }
    );
    stickyObserver.observe(mainAddBtn);
  }

  /* ---- Simple Audio Player ---- */
  /* ---- Product card preview playback + persistent mini player ---- */
  const cardAudio = new Audio();
  cardAudio.preload = 'none';
  let currentSrc = '';
  let currentTitle = '';
  let currentUrl = '';
  let currentVariantId = '';
  let currentPrice = '';
  let currentVariantTitle = '';
  let currentImage = '';
  let isIdleDefault = false;

  const playerBar = document.getElementById('ki-player');
  const pbTitle = playerBar ? playerBar.querySelector('.player-bar__title') : null;
  const pbLicense = playerBar ? playerBar.querySelector('[data-pb-license]') : null;
  const pbToggle = playerBar ? playerBar.querySelector('[data-pb-toggle]') : null;
  const pbNext = playerBar ? playerBar.querySelector('[data-pb-next]') : null;
  const pbPrev = playerBar ? playerBar.querySelector('[data-pb-prev]') : null;
  const pbLink = playerBar ? playerBar.querySelector('[data-pb-link]') : null;
  const pbArt = playerBar ? playerBar.querySelector('.player-bar__art') : null;
  const pbProgress = playerBar ? playerBar.querySelector('.player-bar__progress') : null;

  const PB_ART_ICON = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg>`;

  function updatePbArt() {
    if (!pbArt) return;
    if (currentImage) {
      pbArt.classList.add('player-bar__art--image');
      pbArt.innerHTML = '<img src="' + currentImage + '" alt="" loading="lazy" />';
    } else {
      pbArt.classList.remove('player-bar__art--image');
      pbArt.innerHTML = PB_ART_ICON;
    }
  }

  const PB_PLAY = `<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><polygon points="5 3 19 12 5 21 5 3"/></svg>`;
  const PB_PAUSE = `<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>`;

  function setCardBtnState(btn, playing) {
    btn.classList.toggle('product-card__play--active', playing);
    btn.innerHTML = playing
      ? `<svg width="18" height="18" viewBox="0 0 24 24" fill="white"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>`
      : `<svg width="18" height="18" viewBox="0 0 24 24"><polygon points="5 3 19 12 5 21 5 3" fill="white"/></svg>`;
  }

  function setPbToggle(playing) {
    if (pbToggle) pbToggle.innerHTML = playing ? PB_PAUSE : PB_PLAY;
  }

  function showBar() {
    if (!playerBar) return;
    if (pbTitle && currentTitle) pbTitle.textContent = currentTitle.toUpperCase();
    playerBar.classList.add('is-visible');
  }

  function buildPlaylist() {
    const list = [];
    document.querySelectorAll('.product-card').forEach(card => {
      const src = card.dataset.audioSrc;
      if (src) {
        const vBtn = card.querySelector('[data-variant-id]');
        list.push({
          src: src,
          title: card.dataset.title || 'Untitled',
          url: card.dataset.productUrl || '',
          variantId: (vBtn && vBtn.dataset.variantId) || '',
          price: card.dataset.price || '',
          variantTitle: card.dataset.variantTitle || '',
          image: card.dataset.image || ''
        });
      }
    });
    if (list.length) sessionStorage.setItem('ki_playlist', JSON.stringify(list));
    return list;
  }

  function getPlaylist() {
    try { return JSON.parse(sessionStorage.getItem('ki_playlist') || '[]'); } catch (e) { return []; }
  }

  function updateLink() {
    if (pbLink) pbLink.setAttribute('href', currentUrl || '#');
  }

  function updatePbMeta() {
    if (pbLicense) pbLicense.textContent = currentVariantTitle || 'Basic Lease';
  }

  function saveState() {
    if (!currentSrc) return;
    sessionStorage.setItem('ki_player', JSON.stringify({
      src: currentSrc,
      title: currentTitle,
      url: currentUrl,
      variantId: currentVariantId,
      price: currentPrice,
      variantTitle: currentVariantTitle,
      image: currentImage,
      time: cardAudio.currentTime || 0,
      playing: !cardAudio.paused
    }));
  }

  function syncCardButtons() {
    const playing = !cardAudio.paused;
    document.querySelectorAll('.product-card').forEach(card => {
      const btn = card.querySelector('[data-card-play]');
      if (!btn) return;
      const active = playing && card.dataset.audioSrc && card.dataset.audioSrc === currentSrc;
      setCardBtnState(btn, active);
    });
  }

  function lookupVariantId(src) {
    const match = getPlaylist().find(t => t.src === src);
    return (match && match.variantId) || '';
  }

  function playTrack(src, title, opts) {
    opts = opts || {};
    isIdleDefault = !!opts.idle;
    if (playerBar) playerBar.classList.toggle('player-bar--idle', isIdleDefault);
    currentSrc = src;
    currentTitle = title || '';
    if (typeof opts.url === 'string') currentUrl = opts.url;
    currentVariantId = opts.variantId || lookupVariantId(src);
    const meta = getPlaylist().find(t => t.src === src) || {};
    currentPrice = (typeof opts.price === 'string' && opts.price) || meta.price || '';
    currentVariantTitle = (typeof opts.variantTitle === 'string' && opts.variantTitle) || meta.variantTitle || '';
    currentImage = (typeof opts.image === 'string' && opts.image) || meta.image || '';
    updateLink();
    updatePbMeta();
    updatePbArt();
    if (cardAudio.src.indexOf(src) === -1) cardAudio.src = src;
    if (opts.time) {
      const seek = () => { try { cardAudio.currentTime = opts.time; } catch (e) {} };
      if (cardAudio.readyState >= 1) seek();
      else cardAudio.addEventListener('loadedmetadata', seek, { once: true });
    }
    showBar();
    if (opts.autoplay === false) {
      setPbToggle(false);
      syncCardButtons();
      updateBigPlayers();
      saveState();
    } else {
      cardAudio.play().catch(() => {
        setPbToggle(false);
        syncCardButtons();
        updateBigPlayers();
        saveState();
      });
    }
  }

  function playNext() {
    const list = getPlaylist();
    if (!list.length) return;
    const idx = list.findIndex(t => t.src === currentSrc);
    const next = list[(idx + 1 + list.length) % list.length];
    playTrack(next.src, next.title, { autoplay: true, url: next.url, variantId: next.variantId });
  }

  function playPrev() {
    const list = getPlaylist();
    if (!list.length) return;
    const idx = list.findIndex(t => t.src === currentSrc);
    const prev = list[(idx - 1 + list.length) % list.length];
    playTrack(prev.src, prev.title, { autoplay: true, url: prev.url, variantId: prev.variantId });
  }

  function formatTime(s) {
    if (!s || isNaN(s)) return '0:00';
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60);
    return `${m}:${sec.toString().padStart(2, '0')}`;
  }

  // Full-size product-page player: thin UI bound to the shared transport.
  class AudioPlayer {
    constructor(el) {
      this.el = el;
      this.src = el.dataset.src;
      this.title = el.dataset.title || '';
      this.image = el.dataset.image || '';
      this.playBtn = el.querySelector('.audio-player__play-btn');
      this.progressFill = el.querySelector('.audio-player__progress-fill');
      this.timeEl = el.querySelector('.audio-player__time');
      this.bars = el.querySelectorAll('.audio-player__bar');
      this.progressTrack = el.querySelector('.audio-player__progress');
      el._ui = this;
      this.init();
    }
    init() {
      if (this.playBtn) this.playBtn.addEventListener('click', () => this.toggle());
      if (this.progressTrack) {
        this.progressTrack.addEventListener('click', (e) => {
          if (this.src !== currentSrc || !cardAudio.duration) return;
          const rect = this.progressTrack.getBoundingClientRect();
          const pct = (e.clientX - rect.left) / rect.width;
          cardAudio.currentTime = pct * cardAudio.duration;
        });
      }
    }
    toggle() {
      if (!this.src) return;
      if (currentSrc === this.src) {
        if (cardAudio.paused) cardAudio.play().catch(() => {});
        else cardAudio.pause();
      } else {
        const addBtn = document.querySelector('.product-add-btn');
        const priceEl = document.querySelector('.product-price');
        const selectedLicense = document.querySelector('.license-option.selected .license-option__name');
        playTrack(this.src, this.title, {
          autoplay: true,
          url: window.location.pathname,
          variantId: (addBtn && addBtn.dataset.variantId) || '',
          price: priceEl ? priceEl.textContent.trim() : '',
          variantTitle: selectedLicense ? selectedLicense.textContent.trim() : '',
          image: this.image
        });
      }
    }
    render() {
      const active = this.src && this.src === currentSrc;
      const playing = active && !cardAudio.paused;
      const cur = active ? cardAudio.currentTime : 0;
      const dur = active ? (cardAudio.duration || 0) : 0;
      const pct = dur ? (cur / dur) * 100 : 0;
      if (this.progressFill) this.progressFill.style.width = pct + '%';
      if (this.timeEl) this.timeEl.textContent = `${formatTime(cur)} / ${formatTime(dur)}`;
      if (this.bars.length) {
        const idx = Math.floor((pct / 100) * this.bars.length);
        this.bars.forEach((bar, i) => bar.classList.toggle('played', i < idx));
      }
      if (this.playBtn) {
        this.playBtn.innerHTML = playing
          ? `<svg width="20" height="20" viewBox="0 0 24 24" fill="white"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>`
          : `<svg width="20" height="20" viewBox="0 0 24 24" fill="white"><polygon points="5 3 19 12 5 21 5 3"/></svg>`;
      }
    }
  }

  const bigPlayers = [];
  document.querySelectorAll('.audio-player').forEach(el => { bigPlayers.push(new AudioPlayer(el)); });
  function updateBigPlayers() { bigPlayers.forEach(p => p.render()); }

  cardAudio.addEventListener('play', () => { isIdleDefault = false; if (playerBar) playerBar.classList.remove('player-bar--idle'); setPbToggle(true); showBar(); syncCardButtons(); updateBigPlayers(); saveState(); });
  cardAudio.addEventListener('pause', () => { setPbToggle(false); syncCardButtons(); updateBigPlayers(); saveState(); });
  cardAudio.addEventListener('ended', playNext);

  let lastSave = 0;
  cardAudio.addEventListener('timeupdate', () => {
    if (pbProgress && cardAudio.duration) {
      pbProgress.style.width = (cardAudio.currentTime / cardAudio.duration * 100) + '%';
    }
    updateBigPlayers();
    const now = Date.now();
    if (now - lastSave > 2000 && !cardAudio.paused) { lastSave = now; saveState(); }
  });

  window.addEventListener('beforeunload', saveState);

  document.querySelectorAll('[data-card-play]').forEach(btn => {
    const card = btn.closest('.product-card');
    const src = card ? card.dataset.audioSrc : '';
    const title = card ? (card.dataset.title || '') : '';
    const url = card ? (card.dataset.productUrl || '') : '';
    const vBtn = card ? card.querySelector('[data-variant-id]') : null;
    const cardVariantId = (vBtn && vBtn.dataset.variantId) || '';
    const cardPrice = card ? (card.dataset.price || '') : '';
    const cardVariantTitle = card ? (card.dataset.variantTitle || '') : '';
    const cardImage = card ? (card.dataset.image || '') : '';
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!src) {
        // No preview uploaded — go to the product page instead
        if (url) window.location.href = url;
        return;
      }
      if (currentSrc === src) {
        if (cardAudio.paused) cardAudio.play().catch(() => {});
        else cardAudio.pause();
        return;
      }
      playTrack(src, title, { autoplay: true, url: url, variantId: cardVariantId, price: cardPrice, variantTitle: cardVariantTitle, image: cardImage });
    });
  });

  if (pbToggle) {
    pbToggle.addEventListener('click', () => {
      if (!currentSrc) {
        const list = getPlaylist();
        if (list.length) playTrack(list[0].src, list[0].title, { autoplay: true, url: list[0].url });
        return;
      }
      if (cardAudio.paused) cardAudio.play().catch(() => {});
      else cardAudio.pause();
    });
  }
  if (pbNext) pbNext.addEventListener('click', playNext);
  if (pbPrev) pbPrev.addEventListener('click', playPrev);

  // Load a paused "idle" track so the bar stays visible when nothing is
  // playing. Prefer this page's product; otherwise fall back to the first
  // track in the playlist. Recomputed per page so the idle bar always
  // reflects the current product context.
  function loadIdleDefault() {
    if (!playerBar) return;
    const pagePlayer = document.querySelector('.audio-player');
    const list = getPlaylist();
    let def = null;
    if (pagePlayer && pagePlayer.dataset.src) {
      const addBtn = document.querySelector('.product-add-btn');
      const priceEl = document.querySelector('.product-price');
      const selectedLicense = document.querySelector('.license-option.selected .license-option__name');
      def = {
        src: pagePlayer.dataset.src,
        title: pagePlayer.dataset.title || '',
        url: window.location.pathname,
        variantId: (addBtn && addBtn.dataset.variantId) || '',
        price: priceEl ? priceEl.textContent.trim() : '',
        variantTitle: selectedLicense ? selectedLicense.textContent.trim() : '',
        image: pagePlayer.dataset.image || ''
      };
    } else if (list.length) {
      def = list[0];
    }
    if (def && def.src) {
      playTrack(def.src, def.title, { autoplay: false, idle: true, url: def.url, variantId: def.variantId, price: def.price, variantTitle: def.variantTitle, image: def.image });
    } else {
      showBar();
    }
  }

  const pbClose = playerBar ? playerBar.querySelector('[data-pb-close]') : null;
  if (pbClose) {
    pbClose.addEventListener('click', () => {
      cardAudio.pause();
      try { sessionStorage.removeItem('ki_player'); } catch (e) {}
      loadIdleDefault();
      syncCardButtons();
      updateBigPlayers();
    });
  }

  // Rebuild playlist from this page and resume a track only if it was actually
  // playing when the user navigated; otherwise show the idle default for this
  // page (so a paused/idle bar never carries a stale track across pages).
  buildPlaylist();
  if (playerBar) {
    let saved = null;
    try { saved = JSON.parse(sessionStorage.getItem('ki_player') || 'null'); } catch (e) { saved = null; }
    if (saved && saved.src && saved.playing) {
      playTrack(saved.src, saved.title, { time: saved.time, autoplay: true, url: saved.url, variantId: saved.variantId, price: saved.price, variantTitle: saved.variantTitle, image: saved.image });
    } else {
      loadIdleDefault();
    }
  }

  /* ---- Waveform bars animation on product card hover ---- */
  function randomizeWaveform(container) {
    container.querySelectorAll('.waveform-bar').forEach(bar => {
      const h = Math.floor(Math.random() * 70 + 10);
      bar.style.height = h + '%';
    });
  }

  document.querySelectorAll('.product-card').forEach(card => {
    const waveform = card.querySelector('.product-card__waveform');
    if (waveform) randomizeWaveform(waveform);
  });

  /* ---- Filters ---- */
  const filterPills = document.querySelectorAll('.filter-pill');
  filterPills.forEach(pill => {
    pill.addEventListener('click', () => {
      const group = pill.dataset.group;
      document.querySelectorAll(`.filter-pill[data-group="${group}"]`).forEach(p => p.classList.remove('active'));
      pill.classList.add('active');
      applyFilters();
    });
  });

  function applyFilters() {
    const activeFilters = {};
    document.querySelectorAll('.filter-pill.active').forEach(pill => {
      activeFilters[pill.dataset.group] = pill.dataset.value;
    });

    document.querySelectorAll('.product-card[data-bpm]').forEach(card => {
      let visible = true;
      if (activeFilters.bpm && activeFilters.bpm !== 'all') {
        const bpm = parseInt(card.dataset.bpm);
        const [min, max] = activeFilters.bpm.split('-').map(Number);
        if (max) { visible = visible && bpm >= min && bpm <= max; }
        else { visible = visible && bpm >= min; }
      }
      if (activeFilters.key && activeFilters.key !== 'all') {
        visible = visible && card.dataset.key === activeFilters.key;
      }
      if (activeFilters.genre && activeFilters.genre !== 'all') {
        const normGenre = (s) => (s || '').toLowerCase().replace('&', 'n').replace(/[^a-z-]/g, '');
        visible = visible && normGenre(card.dataset.genre) === normGenre(activeFilters.genre);
      }
      card.style.display = visible ? '' : 'none';
    });

    const grid = document.querySelector('.beats-grid');
    if (grid && activeFilters.sort) {
      const cards = Array.from(grid.querySelectorAll('.product-card[data-bpm]'));
      cards.forEach((card, i) => {
        if (card.dataset.featuredIndex === undefined) card.dataset.featuredIndex = i;
      });
      cards.sort((a, b) => {
        if (activeFilters.sort === 'bpm-asc' || activeFilters.sort === 'bpm-desc') {
          const av = parseInt(a.dataset.bpm) || 0;
          const bv = parseInt(b.dataset.bpm) || 0;
          return activeFilters.sort === 'bpm-asc' ? av - bv : bv - av;
        }
        return parseInt(a.dataset.featuredIndex) - parseInt(b.dataset.featuredIndex);
      });
      cards.forEach(card => grid.appendChild(card));
    }
  }

  /* ---- Hero animations ---- */
  const heroEl = document.querySelector('.hero');
  if (heroEl) {
    setTimeout(() => heroEl.classList.add('loaded'), 100);
  }

  /* ---- Intersection Observer for scroll animations ---- */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    document.querySelectorAll('.product-card, .testimonial-card, .stat-item, .section-header').forEach(el => {
      observer.observe(el);
    });
  }

  /* ---- Init cart count on load ---- */
  updateCartCount();

})();
